import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-531" data-mp="ydoui2n5kgfz">
      {children}
    </motion.div>;
}